import React, { useState, useEffect, useMemo } from "react"
import { getProspectCases } from "../../../apis/cases"
import ReactTable from "../../ReactTable"
import { isEmpty } from "lodash"
import { formatDate } from "@utils/formatters"
import { useContainerWidth } from "../../../hooks/useContainerWidth"

const AccountCasesTable = ({
  prospect,
  accountId,
  reloadCases,
  setActiveCaseGuid,
}) => {
  const [prospectCases, setProspectCases] = useState([])

  // Observe container width to adapt column sizes
  const [containerRef, containerWidth] = useContainerWidth(0)

  useEffect(() => {
    getProspectCases(prospect.prospect_guid, accountId, setProspectCases)
  }, [prospect.prospect_guid, accountId, reloadCases])

  const handleRowClick = (e) => {
    setActiveCaseGuid(e.case_guid)
  }

  const tableColumns = useMemo(() => {
    const base = {
      created: 125,
      dept: 160,
      status: 120,
      category: 180,
      desc: 570,
    }
    const totalBase = Object.values(base).reduce((a, b) => a + b, 0)

    const available = Math.max((containerWidth || totalBase) - 32, 320)

    const scale = Math.min(Math.max(available / totalBase, 0.7), 1.5)

    const calculated_witdh = {
      created: Math.round(base.created * scale),
      dept: Math.round(base.dept * scale),
      status: Math.round(base.status * scale),
      category: Math.round(base.category * scale),
      desc: Math.round(base.desc * scale),
    }

    return [
      {
        Header: "Created",
        accessor: "case_created_dt",
        Cell: (e) => (e.value ? formatDate(e.value) : "N/A"),
        width: calculated_witdh.created,
      },
      {
        Header: "Department",
        accessor: "department_code",
        width: calculated_witdh.dept,
      },
      {
        Header: "Status",
        accessor: "to_case_status_code",
        width: calculated_witdh.status,
      },
      {
        Header: "Category",
        accessor: "category_name",
        width: calculated_witdh.category,
      },
      {
        Header: "Description",
        accessor: "case_description",
        width: calculated_witdh.desc,
      },
    ]
  }, [containerWidth])

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      {!isEmpty(prospectCases) ? (
        <ReactTable
          title="Cases"
          data={prospectCases}
          columns={tableColumns}
          canHover={true}
          handleClick={handleRowClick}
        />
      ) : (
        <p>
          No cases found for connected prospect with GUID{" "}
          {prospect.prospect_guid}
        </p>
      )}
    </div>
  )
}

export default AccountCasesTable
